import { useParams } from "react-router-dom";
import { AdminPageShell } from "@/components/shared/admin-page-shell";
import { RoleFormPage } from "@/features/roles/components/RoleFormPage";
import { useRoles } from "@/features/roles/hooks/useRolesQueries";
import { Spinner } from "@/components/ui/spinner";

export default function RolesEditPage() {
  const { code } = useParams<{ code: string }>();
  const decodedCode = code ? decodeURIComponent(code) : "";
  const { data: roles = [], isLoading } = useRoles();
  const role = roles.find((r) => r.code === decodedCode);

  if (isLoading) {
    return (
      <AdminPageShell title="تعديل الدور">
        <div className="flex justify-center py-12">
          <Spinner className="size-6" />
        </div>
      </AdminPageShell>
    );
  }

  if (!role || role.isSystem) {
    return (
      <AdminPageShell title="تعديل الدور">
        <p className="text-sm text-destructive">الدور غير موجود أو لا يمكن تعديله</p>
      </AdminPageShell>
    );
  }

  return (
    <AdminPageShell title={`تعديل الدور: ${role.name}`}>
      <RoleFormPage role={role} />
    </AdminPageShell>
  );
}
